
export default {
    name: "AppBar",
    components: {
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        canShowAuthButton() {
            if(this.$route.name === 'event' || this.$route.name === 'share-ticket' || this.$route.name === 'almaboipeba') return false;
            return true;
        }
    },
    data: () => ({
        showAuthPopUp: false,
        showMenu: false,
        showMenu2: false,
        term: false,
        itemsMenu: [
            {
                title: 'Experiência 639',
                page: '/experience'
            },
            {
                title: 'Lançamento APP',
                page: '/register-app'
            },
            {
                title: 'Quem Somos',
                page: '/quem-somos'
            }, {
                title: 'Ajuda',
                page: '/suporte'
            },
        ],
        itemsMenu2: [
            {
                title: 'Reflexões',
                page: '/content'
            },
            {
                title: 'Pergunte ao 639',
                page: '/suporte'
            },
        ],
        key: 0,
        policy: false,
        loginMobile: false,
        group: null,
        newJourney: false,
        messageDrawer: false,
        Register: true,
        origin: null,
        source: null
    }),

    methods: {
        login() {
            if (localStorage.getItem("origin") != null) {
                const model = JSON.parse(localStorage.getItem("origin"));
                this.origin = model.origin;
                this.source = model.source;
                window.location.assign(`https://639app.com/auth?utm_source=${this.source}&origem=${this.origin}`)
            } else {
                window.location.assign("https://639app.com/auth")
            }
        },
        routeMethod(i) {
            this.loginMobile = false
            if (i !== undefined) {
                this.$router.push(`${i}`)
            }
        }

    },
};
